import type { FileStatusItem, FileStats } from '../types';

const EMPTY_STATS: FileStats = {
  total: 0,
  errorCount: 0,
  successCount: 0,
  processingCount: 0,
  errorPercentage: 0,
  successPercentage: 0,
};

export function computeStats(files: FileStatusItem[]): FileStats {
  if (files.length === 0) {
    return EMPTY_STATS;
  }

  let errorCount = 0;
  let successCount = 0;
  let processingCount = 0;

  for (const file of files) {
    if (file.status === 'error') {
      errorCount++;
    } else if (file.status === 'success') {
      successCount++;
    } else if (file.status === 'processing') {
      processingCount++;
    }
  }

  const total = files.length;

  return {
    total,
    errorCount,
    successCount,
    processingCount,
    errorPercentage: errorCount / total,
    successPercentage: successCount / total,
  };
}
